module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.it/it_it/azienda/privacy.html",
	"footer.disclaimer.text": "Company Info",
	"footer.disclaimer.url": "https://www.grohe.it/it_it/azienda/note-legali.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "Configuratore di soluzioni per l’acqua GROHE",
	"homepage.introtext": "Rispondi ad alcune semplici domande e trova il sistema per il trattamento dell'acqua GROHE che soddisfa le tue necessità.",
	"homepage.buttonStart": "Vai al configuratore di soluzioni per l’acqua GROHE",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Homa Page",
	"configurator.button.seeResults": "Visualizza i risultatis",
	"question1.question": "Hai una fornitura di acqua calda e fredda nella tua cucina?",
	"question1.option1.text": "Ho una fornitura di acqua calda nella mia cucina",
	"question1.option2.text": "Ho una fornitura di acqua fredda con uno scaldabagno stantaneo installato",
	"question2.question": "Quale tipo di acqua stai cercando?",
	"question2.option1.text": "Acqua bollente filtrata per preparare cibi e bevande",
	"question2.option2.text": "Acqua fresca filtrata, naturale, leggermente frizzante e frizzante da bere",
	"question2.option3.text": "Acqua fresca filtrata, naturale, leggermente frizzante e frizzante e acqua bollente",
	"question3.question": "Desideri continuare ad utilizzare il tuo attuale miscelatore da cucina?",
	"question3.option1.text": "Desidero continuare ad utilizzare il mio attuale miscelatore da cucina",
	"question3.option2.text": "Desidero sostituirlo con un nuovo miscelatore da cucina",
	"question4.question": "Quale dovrebbe essere il tuo miscelatore principale?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Quale design preferici?",
	"question5.option1.text": "Bocca di erogazione a \"L\"",
	"question5.option2.text": "Bocca di erogazione a \"U\"",
	"question5.option3.text": "Bocca di erogazione a \"C\"",
	"question6.question": "Quale tipo di finitura preferisci?",
	"question6.option1.text": "Cromata",
	"question6.option2.text": "Satinata - SuperSteel",
	"question7.question": "Quale capacità d'acqua deve avere il tuo boiler?",
	"question7.option1.text": "Taglia M (3 litri)",
	"question7.option2.text": "Taglia L (5,5 litri)",
	"results.title": "{productGroupsCount, plural, \none {Il tuo risultato} \nother {I tuoi risultati}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Per una corretta installazione avrai bisogno anche di:",
	"results.newConfiguration.title": "Vuoi configurare un nuovo sistema per il trattamento dell’acqua?",
	"results.newConfiguration.buttonText": "Configura un nuovo sistema per il trattamento dell’acqua",
	"results.product.number": "Codice prodotto: #{number}",
	"results.product.button.productInformation": "Informazioni sul prodotto",
	"results.product.button.dealerLocator": "Trova una showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Informazioni sul prodotto",
	"results.product.dealer": "Trova una showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.it_it.json
// module id = 785
// module chunks = 0